import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/max';

export function normalizePhoneNumber(value: string, country: CountryCode = 'SE'): string | null {
  const input = value.trim().replace(/^00/, '+');
  if (!/^\+?[\d\s().-]+$/.test(input)) return null;
  const phone = parsePhoneNumberFromString(input, { defaultCountry: country, extract: false });
  return phone?.isValid() && !phone.ext ? phone.number : null;
}
